import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { COContact, IdValuePair, MailingAddressViewModel } from "@tylertech/tyler-api-types";
import
{
    ContactManagerDialogComponent, ContactManagerDialogData,
    MailingAddressDialogComponent, MailingAddressDialogData
} from "../components";

@Injectable()
export class ContactDialogsService
{
    constructor(private readonly matDialog: MatDialog) { }

    showContactManager(contact: COContact): Promise<COContact>
    {
        const dialogConfig: MatDialogConfig<ContactManagerDialogData> = {
            data: {
                contact
            }
        };
        const dialogRef = this.matDialog.open(ContactManagerDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    showMailingAddress(
        mailingAddresses: Array<MailingAddressViewModel>,
        parentType: string,
        parentId: string,
        inUseMailingAddresses: Array<IdValuePair>,
        viewOnly: boolean
    ): Promise<Array<MailingAddressViewModel>>
    {

        const dialogConfig: MatDialogConfig<MailingAddressDialogData> = {
            data: {
                mailingAddresses,
                parentType,
                parentId,
                inUseMailingAddresses,
                viewOnly
            },
            disableClose: true,
        };
        const dialogRef = this.matDialog.open(MailingAddressDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
